import { useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import BreadcrumbsComp from '@cld/breadcrumbs';
import { KeyboardArrowRight } from '@clds/icon';
import { selectIsResponsiveWidth } from 'root/selectors';
import { selectPanelOpen, selectBreadcrumbsPath } from '../../selectors';
import bindActions, { types as ats } from '../../actions';
import { SEARCH_RESULTS_ID } from '../../data/consts';
import translatePredefinedName from '../../utils/translatePredefinedName';
import { calcMaxCrumbs } from './helpers';

const StyledBreadcrumbs = styled(BreadcrumbsComp)`
  min-width: 0;
  flex: 1 1 auto;

  > :first-child {
    padding-left: 4px;
  }

  .more-crumb {
    flex: 0 0 2rem;
  }
`;

const Divider = () => <KeyboardArrowRight variant="secondary" size="xs" />;

const { SET_NAVIGATION_CURRENT_FOLDER } = ats;

export const Breadcrumbs = ({ isSidePanelOpen, breadcrumbPath = [], isResponsiveWidth, actions }) => {
  const crumbsNames = breadcrumbPath.map((crumb) => translatePredefinedName(crumb.kind, crumb.name) || '');

  const handleClick = useCallback(
    (index) => {
      if (breadcrumbPath[index].id !== SEARCH_RESULTS_ID) {
        actions[SET_NAVIGATION_CURRENT_FOLDER](breadcrumbPath[index]);
      }
    },
    [breadcrumbPath, actions]
  );

  const maxCrumbs = useMemo(() => calcMaxCrumbs(crumbsNames, isSidePanelOpen), [crumbsNames, isSidePanelOpen]);

  return (
    <StyledBreadcrumbs isMobile={isResponsiveWidth} maxCrumbs={maxCrumbs} Divider={Divider} onCrumbClick={handleClick}>
      {crumbsNames}
    </StyledBreadcrumbs>
  );
};

const mapStateToProps = (state) => ({
  isSidePanelOpen: selectPanelOpen(state),
  breadcrumbPath: selectBreadcrumbsPath(state),
  isResponsiveWidth: selectIsResponsiveWidth(state),
});

export default connect(mapStateToProps, (dispatch) => ({
  actions: bindActions(dispatch),
}))(Breadcrumbs);
